import { Modal } from "antd";
import { RootState } from "app.store";
import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setMceModal } from "states/global-value/global-value.slice";
import { MceEditor } from "./mce-editor";

export function MceEditorModal() {
  const dispatch = useDispatch();
  const mceModal = useSelector(
    (state: RootState) => state.globalValue.mceModal,
    shallowEqual
  );
  const [content, setContent] = useState<string>();
  useEffect(() => {
    if (mceModal.show) {
      setContent(mceModal.value);
    }
  }, [mceModal.show]);
  return (
    <Modal
      title="Cập nhật nội dung"
      cancelText="Bỏ qua"
      okText="Lưu lại"
      onOk={() => {
        mceModal.onChange && mceModal.onChange(content);
        dispatch(setMceModal({ show: false }));
      }}
      visible={mceModal.show}
      onCancel={() => {
        dispatch(setMceModal({ show: false }));
      }}
      width={800}
    >
      <MceEditor
        height={500}
        pageContent={content ?? ""}
        onChange={(value) => {
          setContent(value);
        }}
      />
    </Modal>
  );
}
